<template>
  <div>
    <v-row dense>
      <v-col cols="3" align="center">
        <v-checkbox
            label="Показывать удаленные"
            v-model="withDeleted"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-data-table
        :headers="headers"
        :items="items"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="row-item">
            <router-link
                :to="{
              name: 'categories-edit',
              params: { id: item.raw.id },
            }"
            >{{ item.columns.name }}
            </router-link
            >
          </td>
          <td>
            <v-icon v-if="!item.raw.status" left icon="$mdiCheck"></v-icon>
          </td>
          <td>
            <v-icon v-if="item.raw.onSite" left icon="$mdiCheck"></v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {RepositoryFactory} from "@/repositories/RepositoryFactory";

const CategoriesRepository = RepositoryFactory.get("category");
export default {
  data() {
    return {
      items: [],
      headers: [
        {
          title: "Наименование",
          align: "start",
          sortable: false,
          key: "name",
        },
        {
          title: "Удалена",
          align: "start",
          sortable: false,
          key: "status",
        },
        {
          title: "На сайте",
          align: "start",
          sortable: false,
          key: "onSite",
        },
      ],
      withDeleted: false
    }
  },
  mounted() {
    this.list();
  },
  watch:{
    withDeleted(){
      this.list();
    },
  },
  methods: {
    async list() {
      const result = await CategoriesRepository.list(this.withDeleted);
      if (result.data.status === "success") {
        this.items = result.data.data;
        this.items.sort((a, b) => b.id - a.id);
      }
    }
  }
}

</script>
